import React from 'react'
import { PageLayout } from 'app/views/components/layout/page-layout'
import { ServicingDrillPage } from './servicing-drill-page'
import ServicingHeader from './servicing-header'


export function ServicingLandingPage() {

  return (
    <PageLayout>
      <ServicingHeader />
      <ServicingDrillPage />
    </PageLayout>
  )
}